import React from 'react'
import Typography from 'gu-ui-kit/Typography'
import PropTypes from 'prop-types'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'

const PageHeader = (props) => {
  const breakpoints = useBreakpoint()

  return (
    <Typography
      {...props}
      component={'h1'}
      variant={breakpoints.xl ? 'Header-60' : breakpoints.fb ? 'Header-50' : 'Header-40'}
    >
      {props.children}
    </Typography>
  )
}

PageHeader.propTypes = {
  props: PropTypes.object,
  children: PropTypes.node,
}

export default PageHeader
